import React from 'react';
import CoffeehouseFooter from 'src/components/coffeehouse/CoffeehouseFooter';
import CoffeehouseHeader from 'src/components/coffeehouse/CoffeehouseHeader';
import {
    ROUTE_ACCOUNT_DATA,
    ROUTE_ACCOUNT_DATA_ADDRESSES,
    ROUTE_ACCOUNT_DATA_MAIN,
    ROUTE_ACCOUNT_DOWNLOAD,
    ROUTE_ACCOUNT_ORDERS,
    ROUTE_ACCOUNT_SERVICE,
} from 'src/config/account-routes';
import { SiteShellProps } from 'src/config/sites/SiteDefinition';
import { LocaleFilterContext } from 'src/core/provider/LocaleFilterContext';
import { SiteLayoutContext } from 'src/core/provider/SiteLayoutContext';
import CoffeehouseLogo from 'src/resources/icons/CoffeehouseLogo';

const CoffeehouseSidebarLogo: React.FC = () => <CoffeehouseLogo style={{ fontSize: '2.5rem', color: '#6F4E37' }} />;

const coffeehouseLayoutValue = {
    Header: CoffeehouseHeader,
    Footer: CoffeehouseFooter,
    showVolumeDiscount: false,
    showCredits: false,
    SidebarLogo: CoffeehouseSidebarLogo,
    allowedAccountRoutePaths: [
        ROUTE_ACCOUNT_DATA.path,
        ROUTE_ACCOUNT_ORDERS.path,
        ROUTE_ACCOUNT_SERVICE.path,
        ROUTE_ACCOUNT_DOWNLOAD.path,
    ] as const,
    allowedDataTabPaths: [ROUTE_ACCOUNT_DATA_MAIN.path, ROUTE_ACCOUNT_DATA_ADDRESSES.path] as const,
};

const coffeehouseLocaleFilter = {
    allowedLanguages: ['en', 'de', 'lv', 'nl'] as const,
    allowedRegions: ['at', 'lv', 'nl'] as const,
    filterByAddresses: false,
};

const CoffeehouseShell: React.FC<SiteShellProps> = ({ children }) => (
    <SiteLayoutContext.Provider value={coffeehouseLayoutValue}>
        <LocaleFilterContext.Provider value={coffeehouseLocaleFilter}>{children}</LocaleFilterContext.Provider>
    </SiteLayoutContext.Provider>
);

export default CoffeehouseShell;
